export const STORAGE_KEY = 'update-notes-alert-presented-for';
